const subscriptionsLang = {
  modules: {
    pageTitle: 'Gestion des modules'
  },
  cart: {
    title: 'Panier d\'achat'
  },
  withdrawal: {
    status: {
      1: 'En attente de validation',
      2: 'Validée, en attente de paiement',
      3: 'Payée',
      4: 'Refusée'
    }
  }
}

export default {
  subscriptions: subscriptionsLang
}
